import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const project = useConnect('project.byId', {
    id: Number(match.params.projectId)
  });

  if (project.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      project={project}
      page="Grant"
      title="Are you looking for funding to support your project?"
      description={(
        <>
          Funding is not guaranteed. Providing information about your estimated project
          budget will notify your Steward and CommunityShare that you are looking for
          financial or in-kind support. You will be contacted by your local Steward or
          CommunityShare staff if your project qualifies for project mini-grants, in-kind
          resources, or as other funding becomes available.
        </>
      )}
    >
      <Form
        user={user}
        project={project}
        navigation={(
          <Navigation v5={true} activeStep={18} steps={19}/>
        )}
        onPrevious={(newData) => history.push(Urls(project).RESOURCES)}
        onNext={(newData) => project.data.grant === 'Yes' ?
          history.push(Urls(project).BUDGET) :
          history.push(Urls(project).SEARCH_EXPLANATION)
        }
        onSkip={() => project.data.grant === 'Yes' ?
          history.push(Urls(project).BUDGET) :
          history.push(Urls(project).SEARCH_EXPLANATION)
        }
        onExit={() => history.push(Urls(project).PROJECT_EDIT)}
      />
    </ParentLayout>
  );
};
